import React from "react";
import ModernBerichten from "./ModernBerichten";

const Berichten = () => {
  return <ModernBerichten />;
};

export default Berichten;
